import React, { ReactElement } from 'react';
import Svg, { G, Path, Rect } from 'react-native-svg';

import { IconStyles } from './types';

export const Play = ({
  size,
  style,
}: {
  size: number;
  style?: IconStyles;
}): ReactElement => {
  return (
    <Svg width={size} height={size} viewBox="0 0 80 80" style={style}>
      <G transform="translate(-1067 -2537) translate(978 2372) translate(89 165)">
        <Rect
          width="80"
          height="80"
          rx="40"
          fill={style?.color || 'currentColor'}
        />
        <Path
          fill="#FFF"
          fillRule="nonzero"
          d="M30.389 57.6L30.389 22.4 55.61 40z"
        />
      </G>
    </Svg>
  );
};
